import { SDrawerOrModal } from 'shj-components'
import { useEffect, useState } from 'react'
import { Cascader, Col, Form, Input, message, Row} from 'antd'
import { addEvaluationType, getTreeEvaluationType, updateEvaluationType } from '@/services/evaluateConfig.ts'
import { isArray } from 'lodash-es'

const AddOrEditDom = ({ open, record, onClose, reload }: any) => {
  const [submitLoading, setSubmitLoading] = useState(false)
  const [treeList, setTreeList] = useState<any[]>([]);
  const [form] = Form.useForm()

  useEffect(() => {
    if (open) {
      if (isEdit) {
        getSelection();
        console.log('record', record)
        form.setFieldsValue({
          name: record?.label||"",
        });
      }
    }
  }, [open, record])

  const isEdit = (record?.type === 'edit');
  const isDefault = record?.object?.sysConfig;
  const isNext =( record?.type === 'addNext');

  const title = record?.type==='addNext'?'新增下级':record?.type==='edit'?'编辑分类':'新增分类';

  // 处理树形数据，禁用当前和第4级类目和当前节点的子级
  const processTreeData = (data: any[], currentId?: string, currentLvl?: number): any[] => {
    return data.map(item => {
      const newItem = { ...item };

      // 禁用第4级类目
      if (item.object?.lvl === 4) {
        newItem.disabled = true;
      }

      // 新增：禁用所有 lvl 小于等于当前节点 lvl 的节点
      if (currentLvl && item.object?.lvl >= Number(currentLvl)) {
        newItem.disabled = true;
      }

      // 禁用本身
      if (currentId && item.id === currentId) {
        newItem.disabled = true;
      }

      // 递归处理子节点
      if (item.children && item.children.length > 0) {
        newItem.children = processTreeData(item.children, currentId, currentLvl);
      }

      // 禁用当前节点的所有子节点（不能选自己的子级作为父级）
      if (currentId && item.id === currentId) {
        // 递归禁用所有子节点
        const disableChildren = (children: any[]) => {
          children.forEach(child => {
            child.disabled = true;
            if (child.children && child.children.length > 0) {
              disableChildren(child.children);
            }
          });
        };
        if (newItem.children && newItem.children.length > 0) {
          disableChildren(newItem.children);
        }
      }

      return newItem;
    });
  };

  // 获取当前节点的父级路径
  const getParentPath = (data: any[], targetId: string, path: string[] = []): string[] | null => {
    for (const item of data) {
      const currentPath = [...path, item.id];

      if (item.id === targetId) {
        return currentPath;
      }

      if (item.children && item.children.length > 0) {
        const result = getParentPath(item.children, targetId, currentPath);
        if (result) {
          return result;
        }
      }
    }
    return null;
  };

  const getSelection = async () => {
    if (isEdit&&isDefault) return;
    try {
      setSubmitLoading(true)
      const list = await getTreeEvaluationType({ data: {} });
      // const processedList = isArray(list) ? processTreeData(list, record?.id, record?.object?.lvl) : [];
      const processedList = isArray(list) ? list : [];
      setTreeList(processedList);
      // 如果是编辑模式，设置默认父级
      if (isEdit) {
        const parentPath = getParentPath(processedList, record?.parentId);
        if (parentPath) {
          form.setFieldsValue({
            parentId: parentPath
          });
        }
      }
    } finally {
      setSubmitLoading(false)
    }
  }

  // 获取父级ID
  const getParentId = (values: any) => {
    if (isDefault && isEdit) {
      return record?.parentId || "0"; // 系统初始化的分类，不可修改父级
    }
    if (isNext) {
      return record?.id || "0"; // 添加下级
    }
    return values?.parentId?.length ? values.parentId[values.parentId.length - 1] : "0";
  };

  const onFinish = () => {
    form?.validateFields().then((values: any) => {
      const parentId = getParentId(values);
      
      const submitData = {
        ...values,
        parentId,
        id: isEdit ? record?.id : "",
        status: true
      };
      
      // 执行API调用
      const apiFn = isEdit ? updateEvaluationType : addEvaluationType;
      setSubmitLoading(true);
      
      apiFn(submitData)
        .then((res: any) => {
          message.success(res?.message || '操作成功');
          reload?.();
          resetFn();
        })
        .finally(() => setSubmitLoading(false));
    });
  }

  const resetFn = () => {
    onClose?.()
    form?.resetFields()
  }

  return (
    <SDrawerOrModal
      width={500}
      mode="modal"
      title={title}
      open={open}
      onOk={onFinish}
      onCancel={resetFn}
      loading={submitLoading}
      antdProps={{ destroyOnClose: true }}
    >
      <Form form={form} layout={'vertical'} initialValues={{}}>
        <Row gutter={20}>
          {
            isEdit&&!record?.object?.sysConfig? (
              <Col span={24}>
                <Form.Item
                  label={'父级分类'}
                  name="parentId"
                >
                  <Cascader
                    placeholder={'请选择'}
                    showSearch
                    expandTrigger="hover"
                    changeOnSelect
                    options={treeList}
                    fieldNames={{label: 'label', value: 'id'}}
                  />
                </Form.Item>
              </Col>
            ) : null
          }
          <Col span={24}>
            <Form.Item
              label={'分类名称'}
              name={'name'}
              required
              rules={[{ required: true, message: '不能为空' }]}
            >
              <Input placeholder={'请输入'} maxLength={15} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SDrawerOrModal>
  )
}

export default AddOrEditDom
